module.exports = __webpack_public_path__ + "img/bg2.031984e9.jpg";